/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ExternalDocumentTypeDto } from '../../models/external-document-type-dto';

export interface GetDocumentTypesForCustomer$Params {
  customerGUID: string;
}

export function getDocumentTypesForCustomer(http: HttpClient, rootUrl: string, params: GetDocumentTypesForCustomer$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<ExternalDocumentTypeDto>>> {
  const rb = new RequestBuilder(rootUrl, getDocumentTypesForCustomer.PATH, 'get');
  if (params) {
    rb.path('customerGUID', params.customerGUID, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<ExternalDocumentTypeDto>>;
    })
  );
}

getDocumentTypesForCustomer.PATH = '/external-document/types/customers/{customerGUID}';
